import React, { useState } from "react";
import styles from "./toolbarContainer.module.css";
import { Box, Card, CardActionArea, CardContent, Drawer, Tooltip, Typography } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { Outlet } from "react-router-dom";

export const ToolbarContainer = () => {
  const [drawerOpened, setDrawerOpened] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpened(!drawerOpened);
  };

  return (
    <>
      <Box className={styles.toolbarBoxOpener}>
        <Tooltip
          title={<Typography variant="body2">Open toolbar</Typography>}
          placement="right"
          arrow
        >
          <Card className={styles.toolbarBoxOpenerCard} onClick={toggleDrawer}>
            <CardActionArea className={styles.toolbarBoxOpenerCardContent}>
              <CardContent className={styles.toolbarBoxOpenerCardContent}>
                <ChevronLeft />
              </CardContent>
            </CardActionArea>
          </Card>
        </Tooltip>
      </Box>

      <Box className={styles.toolbarBox}>
        <Outlet />
      </Box>

      <Drawer
        open={drawerOpened}
        onClose={toggleDrawer}
        anchor={"right"}
        slotProps={
          {
            paper: {
              className: styles.drawerPaper,
            }
          }
        }
      >
        <Outlet />
      </Drawer>
    </>
  );
};
